module.exports = __webpack_public_path__ + "static/media/IMG_8243.6d2f02a3.JPG";